<template>
  <UIDialog :is-open :title :z-index size="sm" @close="handleClose">
    <CurrencyForm :instance="modal.entity" @close="handleClose" />
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { AssetClass } from '..'
import { ModalClass } from '@types'

import { CURRENCY_MODAL_TITLE, CURRENCY_MODAL_TITLE_NEW } from './utils/const'

import { UIDialog } from '@ui/modals'
import CurrencyForm from './CurrencyForm.vue'

type Props = {
  modal: ModalClass<AssetClass>
}
const props = defineProps<Props>()

const title = computed(() =>
  props.modal.entity.isNew ? CURRENCY_MODAL_TITLE_NEW : CURRENCY_MODAL_TITLE,
)

const isOpen = computed(() => props.modal.isOpened)

const zIndex = computed(() => props.modal.zIndex)

const handleClose = () => {
  props.modal.conditionalClose()
}
</script>
